import { useCallback } from 'react'
import { FileResponse } from "shared/api"
import { FormDialog } from 'components/dialog/form'

import { ManufacturerResult, usePostManufacturer } from "interface/manufacturer"
import { useManufacturerForm, ManufacturerForm } from "../form"

type AddManufacturerDialogProps = {
  onClose: () => void
	onAddManufacturer: (result: ManufacturerResult, logo?: FileResponse) => void
}
export const AddManufacturerDialog = ({
  onClose,
  onAddManufacturer,
}: AddManufacturerDialogProps) => {
  const onPosted = useCallback(
    (result: ManufacturerResult) => {
      onAddManufacturer(result)
      onClose()
    },
    [onAddManufacturer, onClose]
  )
  const [addManufacturerState, addManufacturer] = usePostManufacturer({ onPosted })
  const form = useManufacturerForm({ onSubmit: addManufacturer })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="新規製薬企業を登録"
      isLoading={addManufacturerState.posting}
      error={addManufacturerState.error}
      body={<ManufacturerForm {...form}/>}
      submitLabel="登録"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
